// DO NOT EDIT THIS FILE. This file auto-generated, use `npm run sync-icons` to update icons

export { ReactComponent as LoginBg2Icon } from '../svg/loginBg2.svg'
